import React from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import './Projects.scss';

// import required modules
import { Keyboard, Navigation, Pagination } from 'swiper';
import images from '~/assets/images';
import Button from '../Button/Button';
import { LeftChervonIcon, RightChervonIcon } from '../Icons/Icons';

export default function App() {
    return (
        <div className="wrapper_project" id="portfolio">
            <div className="inner_project grid wide">
                <div className="header_project">
                    <h1>MỘT SỐ SẢN PHẨM DO MÌNH VIẾT RA...</h1>
                    <p className="des_project">
                        Dưới đây là một số sản phẩm do mình viết ra, một số được phát triển thêm từ sự hướng dẫn của
                        người khác. Có sản phẩm sử dụng ReactJS, một số thuần HTML, CSS hoặc thuần JavaScript.
                    </p>
                </div>
                <div>
                    <Swiper
                        keyboard={{
                            enabled: true,
                        }}
                        pagination={{
                            clickable: true,
                        }}
                        navigation
                        breakpoints={{
                            0: {
                                slidesPerView: 1,
                            },
                            720: {
                                slidesPerView: 2,
                            },
                            1024: {
                                slidesPerView: 3,
                            },
                        }}
                        grabCursor
                        modules={[Keyboard, Navigation, Pagination]}
                        className="mySwiper"
                    >
                        <SwiperSlide>
                            <div className="body-item_project">
                                <div className="item-inner_project">
                                    <div className="image_project">
                                        <img src={images.band} alt="img-project" className="image-inside_project" />
                                    </div>
                                    <div className="content_project">
                                        <h2>Band</h2>
                                        <p>
                                            Đây là trang website đầu tiên mình đặt tay viết ra dưới sự hướng dẫn của Anh
                                            Sơn. Ở sản phẩm này, mình lần đầu được làm quen với HTML, CSS và sự thích
                                            thú về UX bắt đầu từ đây.
                                        </p>
                                    </div>
                                </div>

                                <div className="view_more">
                                    <div className="view_more-btn">
                                        <Button
                                            outline
                                            target="_blank"
                                            className="btn"
                                            href="https://w3band-anh.netlify.app"
                                        >
                                            Xem Demo
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="body-item_project">
                                <div className="item-inner_project">
                                    <div className="image_project">
                                        <img src={images.tiktok} alt="img-project" className="image-inside_project" />
                                    </div>
                                    <div className="content_project">
                                        <h2>TikTok</h2>
                                        <p>
                                            Mình đánh giá đây là sản phẩm phức tạp nhất mình từng làm, mặc dù Anh Sơn
                                            hướng dẫn khá chi tiết nhưng cũng phải mất một thời gian mình mới hiểu cách
                                            hoạt động của ReactJS. Ở sản phẩm này mình học được cách sử dụng component,
                                            hooks và routing trong ReactJS.
                                        </p>
                                    </div>
                                </div>

                                <div className="view_more">
                                    <div className="view_more-btn">
                                        <Button
                                            outline
                                            target="_blank"
                                            className="btn"
                                            href="https://tiktok-anh.netlify.app"
                                        >
                                            Xem Demo
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="body-item_project">
                                <div className="item-inner_project">
                                    <div className="image_project">
                                        <img
                                            src={images.music_app}
                                            alt="img-project"
                                            className="image-inside_project"
                                        />
                                    </div>
                                    <div className="content_project">
                                        <h2>Music App</h2>
                                        <p>
                                            Sản phẩm này được xây dựng chủ yếu để "luyện" về UI, thành thạo hơn trong
                                            việc sử dụng CSS tạo styles cho Website. Có một số logic xử lý được ứng dụng
                                            vào trong nhưng không nhiều.
                                        </p>
                                    </div>
                                </div>

                                <div className="view_more">
                                    <div className="view_more-btn">
                                        <Button
                                            outline
                                            target="_blank"
                                            className="btn"
                                            href="https://music-anh.netlify.app"
                                        >
                                            Xem Demo
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="body-item_project">
                                <div className="item-inner_project">
                                    <div className="image_project">
                                        <img
                                            src={images.dashboard}
                                            alt="img-project"
                                            className="image-inside_project"
                                        />
                                    </div>
                                    <div className="content_project">
                                        <h2>Admin Dashboard</h2>
                                        <p>
                                            Sản phẩm này được xây dựng hoàn toàn bằng HTML và CSS. Không có xử lý logic
                                            trong sản phẩm này. Ở sản phẩm này, mình học được nhiều hơn về Responsive đa
                                            thiết bị.
                                        </p>
                                    </div>
                                </div>

                                <div className="view_more">
                                    <div className="view_more-btn">
                                        <Button
                                            outline
                                            target="_blank"
                                            className="btn"
                                            href="https://dashboard-anh.netlify.app"
                                        >
                                            Xem Demo
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="body-item_project">
                                <div className="item-inner_project">
                                    <div className="image_project">
                                        <img src={images.shopee} alt="img-project" className="image-inside_project" />
                                    </div>
                                    <div className="content_project">
                                        <h2>Shopee</h2>
                                        <p>
                                            Đây là sản phẩm viết ra từ một bài thực hành trong F8. Ở sản phẩm này, mình
                                            học được cách viết ra một thư viện dùng cho Responsive sử dụng Grid-System,
                                            và áp dụng vào trong xử lý UI đa thiết bị.
                                        </p>
                                    </div>
                                </div>

                                <div className="view_more">
                                    <div className="view_more-btn">
                                        <Button
                                            outline
                                            target="_blank"
                                            className="btn"
                                            href="https://shopee-anh.netlify.app"
                                        >
                                            Xem Demo
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                        <div className="swiper-button-next btn-wrapper">
                            <button className="swiper_btn">
                                <RightChervonIcon className="swiper_btn-icon" />
                            </button>
                        </div>
                        <div className="swiper-button-prev btn-wrapper">
                            <button className="swiper_btn">
                                <LeftChervonIcon className="swiper_btn-icon" />
                            </button>
                        </div>
                    </Swiper>
                </div>
            </div>
        </div>
    );
}
